export var PageStatuses;
(function (PageStatuses) {
    PageStatuses["processing"] = "processing";
    PageStatuses["validated"] = "validated";
    PageStatuses["ready"] = "ready";
})(PageStatuses || (PageStatuses = {}));
